// extracted by mini-css-extract-plugin
var _1 = "tjs-help-button__helpBtn tjs-_buttons__btn tjs-_buttons__btn--map";
export { _1 as "helpBtn" }
export default { "helpBtn": _1 }
